import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { TextField } from '@mui/material';
import VMasker from 'vanilla-masker';

class MaskedTextInputDiscount extends Component {
  constructor(props) {
    super(props);
    if (props.value) { //if store has value relative to this component, initialize the state value
      this.state = { ...this.state, value: VMasker.toPattern(props.value, { pattern: props.mask }), error: "" };
    }
    else //in case the store does not have any value for this component, just clear it
      this.state = { ...this.state, value: "", error: "" };

    //this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.value && newProps.value !== this.state.value) {//if store's value relative to this component change, update the state value
      this.setState({ value: VMasker.toPattern(newProps.value, { pattern: newProps.mask }) });
    }
    else if (!newProps.value)//in case the store does not have any value for this component, just clear it
      this.setState({ value: "" });

    if (newProps.error && newProps.error !== this.state.error)
      this.setState({ error: newProps.error });
  }

  onChange = (event) => {
    if (event && event.target) {
      let value = event.target.value;
      if (this.props.max && this.props.max < value) {
        value = this.props.max.toString();
      }
      const masked = VMasker.toPattern(value, { pattern: this.props.mask });//.apply(value, this.props.mask);
      this.setState({ value: masked });
      this.updateStore(value);
    }
  }


  onBlur = (event) => {
    if (event && event.target) {
      const masked = VMasker.toPattern(event.target.value, { pattern: this.props.mask });
      this.updateStore(masked);
    }
  }


  updateStore(value) {
    const p = this.props;
    this.props.dispatch({ type: types.FORM_INPUT, value, name: p.name });

    if (p.name.includes("POSProductDiscountPercentage")) {
      let discountAmount = (p.originalPrice * value / 100).toFixed(2);
      let newPrice = (p.originalPrice - discountAmount).toFixed(2);
      let productId = this.props.name.split('-')[1];
      this.props.dispatch({ type: types.FORM_INPUT, value: discountAmount, name: "POSProductDiscountAmount-" + productId });
      this.props.dispatch({ type: types.FORM_INPUT, value: newPrice, name: "POSProductDiscountNewPrice-" + productId });
    }

  }

  render() {
    const p = this.props;
    //const s = this.state || {};
    const e = this.state && this.state.error;
    const value = this.state && this.state.value;

    const { userAutorizationLevel, className, error, dispatch, patternErrorMsg, pattern, ...textProps } = { ...p };

    return (
      <div className={p.className || "form-group"}>
        {/* <TextField type={p.type || "text"} id={p.id || p.name} name={p.name} hintText={p.mask} fullWidth={p.fullWidth} underlineShow={p.underlineShow} inputStyle={{ textTransform: "uppercase" }}
          placeholder={p.placeholder} floatingLabelText={p.floatingLabelText} value={this.state.value} onChange={(e) => this.onChange(e)} onBlur={(e) => this.onBlur()} maxLength={p.maxLength}
          errorText={e && (value.trim() === ' ' || value.trim() === '' || value.trim().length !== p.mask.length) ? p.error : ''} /> */}

        <TextField
          type={p.type || "text"}
          id={p.id || p.name}
          name={p.name}
          fullWidth={p.fullWidth}
          variant="standard"
          InputLabelProps={{ shrink: true }}
          InputProps={{
            style: { textTransform: "uppercase" },
            inputProps: { maxLength: p.maxLength },
          }}
          placeholder={p.placeholder || p.mask}
          label={p.floatingLabelText || p.label}
          value={value}
          onChange={(e) => this.onChange(e)}
          onBlur={(e) => this.onBlur()}
          error={e && (value.trim() === '' || value.trim().length !== p.mask.length)}
          helperText={e && (value.trim() === '' || value.trim().length !== p.mask.length) ? p.error : ''}
        />
      </div>);
  }
}

const mapStateToProps = (state, props) => {
  return {
    value: state.form[props.name],
    error: state.form && state.form.error && state.form.error[props.name]
  };
};

export default connect(mapStateToProps)(MaskedTextInputDiscount);